import type { Snippet } from 'svelte';
import type { Color } from '@athena-lib/colors';
import type { DeviceName } from '@athena-lib/device';
import { getResponsiveClasses } from '@athena-lib/responsive-utils';

export type TextSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
export type ResponsiveTextSize = Partial<Record<DeviceName, TextSize>>;

export type TextProps = {
  id?: string;
  children: Snippet;
  size?: TextSize | ResponsiveTextSize;
  class?: string;
  color?: Color;
  element?: 'p' | 'span' | 'div';
  italic?: boolean;
  bold?: boolean;
};

export function getTextSizeClasses(size: TextSize | ResponsiveTextSize | undefined) {
  return getResponsiveClasses(size, textSizes);
}

export const textSizes = {
  default: {
    xsmall: 'text-xs',
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg',
    xlarge: 'text-xl',
  },

  md: {
    xsmall: 'md:text-xs',
    small: 'md:text-sm',
    medium: 'md:text-base',
    large: 'md:text-lg',
    xlarge: 'md:text-xl',
  },

  lg: {
    xsmall: 'lg:text-xs',
    small: 'lg:text-sm',
    medium: 'lg:text-base',
    large: 'lg:text-lg',
    xlarge: 'lg:text-xl',
  },
};
